import {
  LOADING_PROFILE,
  LOAD_PROFILE,
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_REQUEST_SUCCESS,
  PROFILE_SAVE_REQUEST,
  PROFILE_SAVE_SUCCESS,
} from "../types/profile.types";

export type profileStateType = {
  profile: null | any;
  total: number;
  current: number;
  loading: boolean;
  save: boolean;
};

const initialState: profileStateType = {
  profile: null,
  total: 0,
  current: 1,
  loading: false,
  save: false,
};

export default function profileReducer(state = initialState, action: any) {
  switch (action.type) {
    case LOAD_PROFILE:
      return {
        loading: false,
        profile: action.payload.results,
      };
    case LOADING_PROFILE:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PROFILE_REQUEST:
      return {
        ...state,
        user: null,
        loading: true,
      };
    case FETCH_PROFILE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        profile: action.payload,
      };
    case PROFILE_SAVE_REQUEST:
      return {
        ...state,
        save: true,
      };
    case PROFILE_SAVE_SUCCESS:
      return {
        ...state,
        save: false,
      };
    default:
      return state;
  }
}
